import { useState } from "react";
import SectionHeading from "./SectionHeading";

const SUBMIT_URL = "https://readdy.ai/api/form/da1i9plrlbpoffc5h7bg";

type Status = "idle" | "loading" | "success" | "error";

export default function Newsletter() {
  const [status, setStatus] = useState<Status>("idle");
  const [formError, setFormError] = useState("");

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);

    const honeypot = String(fd.get("company_alt") || "").trim();
    if (honeypot) {
      setStatus("success");
      form.reset();
      return;
    }

    const params = new URLSearchParams();
    fd.forEach((value, key) => {
      if (key === "company_alt") return;
      params.append(key, String(value));
    });

    setStatus("loading");
    setFormError("");
    try {
      const res = await fetch(SUBMIT_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: params.toString(),
      });
      const responseText = await res.text();
      let parsed: { code?: string; message?: string; meta?: { message?: string; detail?: string } } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
      if (res.ok && parsed?.code === "OK") {
        setStatus("success");
        form.reset();
      } else {
        setStatus("error");
        setFormError(serverMsg || "订阅失败，请稍后再试。");
      }
    } catch {
      setStatus("error");
      setFormError("网络异常，请稍后再试。");
    }
  };

  return (
    <section id="subscribe" className="bg-background-100/70 py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-primary-600 via-primary-500 to-accent-500 px-6 py-12 md:px-12 md:py-16">
          <div className="pointer-events-none absolute -right-10 -top-10 h-52 w-52 rounded-full bg-white/10"></div>
          <div className="pointer-events-none absolute -bottom-16 right-24 h-64 w-64 rounded-full bg-white/10"></div>

          <div className="relative flex flex-col items-start justify-between gap-8 lg:flex-row lg:items-center">
            <div className="max-w-xl">
              <SectionHeading
                eyebrow="订阅更新"
                title="每周精选好漫画，直送到你邮箱"
                subtitle="订阅香香漫画，每周为你整理最新高分作品、热门排行与宝藏专题，再也不怕错过好看漫画。"
                light
              />
            </div>

            <form
              onSubmit={onSubmit}
              data-readdy-form="漫画资讯订阅"
              className="relative w-full max-w-md"
            >
              <div className="flex flex-col gap-3 sm:flex-row">
                <input
                  type="email"
                  name="email"
                  required
                  placeholder="输入你的邮箱地址"
                  aria-label="邮箱地址"
                  className="h-12 w-full rounded-full border border-white/25 bg-white/15 px-5 text-sm text-white placeholder:text-white/60 outline-none focus:border-white/50"
                />
                <button
                  type="submit"
                  disabled={status === "loading"}
                  className="h-12 shrink-0 whitespace-nowrap rounded-full bg-background-50 px-7 text-sm font-medium text-primary-700 transition-colors hover:bg-background-100 disabled:opacity-70"
                >
                  {status === "loading" ? "提交中..." : "订阅"}
                </button>
              </div>

              <div className="antispam-meta">
                <input
                  type="text"
                  name="company_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                />
              </div>

              {status === "success" && (
                <p className="mt-3 flex items-center gap-2 text-sm text-white">
                  <i className="ri-checkbox-circle-fill" aria-hidden="true"></i>
                  订阅成功，感谢关注香香漫画！
                </p>
              )}
              {status === "error" && (
                <p className="mt-3 flex items-center gap-2 text-sm text-white">
                  <i className="ri-error-warning-fill" aria-hidden="true"></i>
                  {formError}
                </p>
              )}
              <p className="mt-3 text-xs text-white/70">
                订阅即表示你同意接收香香漫画的精选推荐，可随时退订。
              </p>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}